export const envTypeEnvVarName = "REACT_APP_ENV_TYPE";
export const envTypeDev = "development";
export const envTypeStaging = "staging";
export const envTypeProd = "production";

export function getEnvType(): string {
  return getEnvVarOrFail(envTypeEnvVarName);
}
export function isDevEnv(): boolean {
  return getEnvType() === envTypeDev;
}

export function getEnvVar(varName: string): string | undefined {
  return process.env[varName];
}

export function isProdEnv(): boolean {
  return getEnvType() === envTypeProd;
}

export function isStagingEnv(): boolean {
  return getEnvType() === envTypeStaging;
}

export function getEnvVarOrFail(varName: string): string {
  const value = getEnvVar(varName);
  if (!value || value.trim().length < 1) {
    throw new Error(`Missing ${varName} env var`);
  }
  return value;
}

// used for early access features, e.g. showing V2 dashboard instead of V1 while in development
const CHRIS_SMITH_ATHENA_ID = "a-1959384.E-859173";
const BOB_FISCHER_ATHENA_ID = "a-1959384.E-859177";
const CHRIS_SMITH_CANVAS_ID = "2f4c25a555784f288c90e0ae1d4e167d";
const BOB_FISCHER_CANVAS_ID = "cf3a3c8c216f4df7b3ffa2e7627d9702";
const CHRIS_SMITH_ELATION_ID = "143222517989377";
const CHRIS_SMITH_2_ELATION_ID = "143224267407361";
const BOB_FISCHER_ELATION_ID = "143320990810113";
export function isMetriportDemoPatient(ehrPatientId: string | undefined): boolean {
  return (
    ehrPatientId === CHRIS_SMITH_ATHENA_ID ||
    ehrPatientId === BOB_FISCHER_ATHENA_ID ||
    ehrPatientId === CHRIS_SMITH_CANVAS_ID ||
    ehrPatientId === BOB_FISCHER_CANVAS_ID ||
    ehrPatientId === CHRIS_SMITH_ELATION_ID ||
    ehrPatientId === CHRIS_SMITH_2_ELATION_ID ||
    ehrPatientId === BOB_FISCHER_ELATION_ID
  );
}
